<template>
  <div class="section-main__warp controlManage-page">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <!-- 表格列 状态 -->
      <!-- <template slot="status"
                slot-scope="scope">
        <el-switch v-auth="'/assetinspection/inspectionPlan:updateStatus'"
                   v-model="scope.row.status"
                   disabled
                   active-value="1"
                   inactive-value="2"
                   @change="handleUpdateStatus(scope.row)"></el-switch>
        {{ scope.row.$status }}
      </template> -->
      <template slot="search_createTime">
        <div>
          <el-date-picker
            v-model="searchParams.time"
            type="datetimerange"
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <!-- <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="searchParams.startTime"
            default-time="00:00:00"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="searchParams.endTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker> -->
        </div>
      </template>
      <template slot="controlRecordName" slot-scope="scope">
        <span style="cursor: pointer" @click="handleView(scope.row)">
          {{ scope.row.controlRecordName }}</span
        >
      </template>
      <!-- 操作栏 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <app-panel
      class="app-panel"
      :isExpand="dialogVisible"
      :width="500"
      @cancel="dialogVisible = false"
      title="布控详情"
    >
      <!-- <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%"
      v-dialogDrag
    > -->
      <div class="flex-row detail-item">
        <div class="label">布控分类 ：</div>
        <span class="c-wt">{{ detailInfo.recordTypeLabel }}</span>
      </div>
      <div class="flex-row detail-item">
        <div class="label">布控名称 ：</div>
        <span class="c-wt">{{ detailInfo.controlRecordName }}</span>
      </div>
      <div class="flex-row detail-item">
        <div class="label">创建时间 ：</div>
        <span class="c-wt">{{ detailInfo.createTime }}</span>
      </div>
      <div class="flex-row detail-item">
        <div class="label">布控摄像头 ：</div>
        <el-scrollbar class="camera-list">
          <div
            v-for="item in detailInfo.cameraList"
            :key="item.thirdDeviceId"
            :class="[
              'camera-list_item flex-row',
              item.cameraStatus === '1' ? 'c-wt' : 'color-fail'
            ]"
          >
            <span class="mr5">{{ item.deviceName }}</span>
            <div
              :class="[
                'status-icon iconfont-lunan',
                item.cameraStatus === '1'
                  ? 'icon-lunan-dui color-success'
                  : 'icon-lunan-cuo'
              ]"
            ></div>
          </div>
        </el-scrollbar>
      </div>
      <div class="flex-row detail-item">
        <div class="label">布控描述 ：</div>
        <span class="c-wt">{{ detailInfo.desc }}</span>
      </div>
      <!-- </el-dialog> -->
    </app-panel>
  </div>
</template>
<script>
import { api } from "../api";
import tableOption from "../const/record";
import utils from "@src/common/utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Dates } from "$utils";

export default {
  components: {
    appPanel
  },
  data() {
    return {
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      searchParams: {
        controlRecordName: "",
        startTime: "",
        endTime: "",
        time: []
      },
      option: tableOption(this),
      dialogVisible: false,
      detailInfo: {}
    };
  },
  mounted() {},
  created() {
    this.getList();
  },
  methods: {
    handleSearchReset() {
      this.searchParams = {};
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.getList();
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      console.log("表格查询参数", this.searchParams);
      const params = Object.assign(this.searchParams, {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      });
      this.$fetch(api.queryControlTaskRecord, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          this.tableData = response.returnObj.list
            ? response.returnObj.list
            : [];
          this.page.total = response.returnObj.total
            ? response.returnObj.total
            : 0;
        }
      });
    },
    handleSearchChange(param) {
      this.$log.info("查询按钮--参数", param);
      console.log(param, this.searchParams, "==para");
      this.searchParams.controlRecordName = param.controlRecordName;
      this.searchParams.startTime = Dates.format(this.searchParams.time[0]);
      this.searchParams.endTime = Dates.format(this.searchParams.time[1]);
      this.page.currentPage = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleView(row) {
      this.dialogVisible = true;
      this.$fetch(api.queryControlTaskRecordDetail, {
        controlRecordCode: row.controlRecordCode
      }).then((res) => {
        if (res.success) {
          this.detailInfo = res.returnObj;
          this.detailInfo.recordTypeLabel = Dic.findByValue(
            "SENU081",
            this.detailInfo.controlRecordType
          );
          this.detailInfo.cameraList = res.returnObj.cameraList;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.controlManage-page {
  .status-icon {
    font-size: 16px;
  }
  .color-success {
    @include set_theme_color(color, default-button-bgcolor);
  }
  .color-fail {
    color: #ee7524;
  }
  .detail-item {
    margin: 15px 0;
    .label {
      margin-right: 10px;
      width: 120px;
      text-align: right;
      flex-shrink: 0;
    }
    .c-wt {
      color: #000000;
    }
  }
  .camera-list {
    max-height: 300px;
  }
  .camera-list_item {
    margin-bottom: 25px;
  }
}
</style>
